// 实际项目替换为后端接口，这里模拟返回星途杯配置
export const getWebsiteConfig = async (type = 'starPathCup') => {
    // 关键：使用type参数（避免未使用报错）
    console.log('当前官网类型：', type);

    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                base: {
                    title: "星途杯 · 新星选拔大赛",
                    slogan: "星才绽放 逐梦巅峰 你的闪耀从不设限",
                    bannerBg: "https://picsum.photos/id/1062/1920/600", // 顶部banner背景图
                },
                theme: {
                    primaryColor: "#FF4D7D", // 主色（粉色）
                    secondaryColor: "#FF9EB5", // 辅助色
                    textColor: "#333333",
                    lightBg: "#FFF9FB", // 浅色背景
                },
                orgData: {
                    // 主办单位
                    host: {
                        name: "星光艺术传媒有限公司",
                        contactPerson: "李经理",
                        phone: "138-8888-8888",
                        address: "北京市朝阳区建国路88号星光大厦15层",
                        introText: "星光艺术传媒有限公司成立于2010年，是国内领先的青少年艺术赛事运营机构，专注于为4-16岁少年儿童提供专业的艺术展示、选拔、孵化平台。累计举办全国性赛事50+场，服务选手超10万人次，与200+艺术院校、媒体平台达成长期合作。",
                        introImages: ["https://q9.itc.cn/q_70/images01/20250115/a18c4bf7787b4f7aaeea301ac63b38e6.jpeg","https://picsum.photos/id/1072/400/300","https://picsum.photos/id/1073/400/300"],
                        introVideo: "https://xtwy-gns.oss-cn-beijing.aliyuncs.com/crmebimage/public/product/2025/08/29/94d73c488dcc47769840d85aa869b77100hq76gwt1.mp4", // 模拟视频链接
                        officialLink: "https://www.baidu.com" // 官方网站
                    },
                    // 承办单位
                    undertake: {
                        name: "少年梦想文化传播有限公司",
                        contactPerson: "张主管",
                        phone: "139-9999-9999",
                        address: "上海市浦东新区张江高科技园区博云路2号梦想中心8层",
                        introText: "少年梦想文化传播有限公司是专注于青少年文化艺术推广的专业机构，核心业务包括赛事执行、艺术培训、文化展演、品牌代言等。拥有专业的执行团队和全国30+省市的线下执行网络，曾成功承办多场全国性青少年赛事，以高效、专业的服务获得行业广泛认可。",
                        introImages: [
                            "https://picsum.photos/id/1080/400/300", // 公司办公环境
                            "https://picsum.photos/id/1081/400/300", // 赛事执行现场
                            "https://picsum.photos/id/1082/400/300"  // 获奖选手颁奖
                        ],
                        introVideo: "https://xtwy-gns.oss-cn-beijing.aliyuncs.com/crmebimage/public/product/2025/08/29/94d73c488dcc47769840d85aa869b77100hq76gwt1.mp4", // 模拟视频链接
                        officialLink: "https://www.baidu.com" // 官方网站
                    }
                },
                sections: [
                    {
                        id: "nav",
                        title: "",
                        component: "NavStep",
                        data: [
                            { label: "大赛简介", link: "#intro" },
                            { label: "往届回顾", link: "#review" },
                            { label: "赛制赛程", link: "#schedule" },
                            { label: "选手出路", link: "#path" },
                            { label: "立即报名", link: "#register" },

                        ],
                    },
                    {
                        id: "intro",
                        title: "01 大赛简介",
                        desc: "专为4-16岁少年儿童打造的综合性艺术赛事",
                        component: "IntroCard",
                        // 新增：视频链接（匹配参考图左侧视频）
                        video: "https://vdept3.bdstatic.com/mda-rkqyyfn5e33hngun/360p/h264/1764112639611055547/mda-rkqyyfn5e33hngun.mp4",
                        data: {
                            modules: [
                                {
                                    type: "theme",
                                    title: "大赛主题",
                                    content: "大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛" +
                                        "主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题大赛主题"
                                },
                                {
                                    type: "advantage",
                                    title: "参赛优势",
                                    content: "参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛" +
                                        "优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势参赛优势",

                                },
                                {
                                    type: "welfare",
                                    title: "参赛福利",
                                    content: "基地福利（在娱乐世界平台选手自动赠送基地给与的旅游免费套票"
                                }
                            ]
                        },
                    },

                    {
                        id: "review",
                        title: "02 往届回顾",
                        desc: "见证数万少年的艺术成长之路",
                            component: "ReviewGallery",
                        data: {
                            photos: [
                                { url: "https://picsum.photos/id/1059/400/300", desc: "第一届全国总决赛现场" },
                                { url: "https://picsum.photos/id/1060/400/300", desc: "少儿朗诵专场展演" },
                                { url: "https://picsum.photos/id/1061/400/300", desc: "绘画赛道获奖作品展览" },
                                { url: "https://picsum.photos/id/1063/400/300", desc: "选手与评委合影留念" },
                                { url: "https://picsum.photos/id/1064/400/300", desc: "舞蹈专场精彩瞬间" },
                                { url: "https://picsum.photos/id/1066/400/300", desc: "颁奖典礼现场" },
                            ],
                        },
                    },
                    {
                        id: "schedule",
                        title: "03 赛制赛程",
                        desc: "清晰赛程安排，助力选手高效备赛",
                        component: "ScheduleStep",
                        data: {
                            steps: [
                                {
                                    stage: "海选",
                                    name: "", // 图中海选无副标题，留空
                                    time: "", // 图中无具体时间，留空
                                    desc: "由各参赛机构自行举办，并实时上传举办视频和选手简介以及评选结果，到赛事线上评选系统！"
                                },
                                {
                                    stage: "初赛",
                                    name: "", // 图中初赛无副标题，留空
                                    time: "", // 图中无具体时间，留空
                                    desc: "由赛事当地代理委派评选人员进驻参赛机构，进行现场评选，并对评选过程进行全程录制上传！"
                                },
                                {
                                    stage: "复赛",
                                    name: "", // 图中复赛无副标题，留空
                                    time: "", // 图中无具体时间，留空
                                    desc: "各区域晋级选手，按指定时间到指定城市参加线下复赛，评选全程线上直播！"
                                },
                                {
                                    stage: "总决赛",
                                    name: "", // 图中总决赛无副标题，留空
                                    time: "", // 图中无具体时间，留空
                                    desc: "全国各区域晋级选手齐聚一堂，进行最终对决，评选出各项目各组别全国金银铜奖！"
                                }
                            ]
                        }
                    },
                    {
                        id: "path",
                        title: "05 选手出路",
                        desc: "为优秀选手提供多元化发展通道",
                        component: "PathList",
                        data: {
                            bannerImg: "https://picsum.photos/id/1074/800/400",
                            broadcastPlatforms: {
                                title: "赛事播放",
                                lists: [
                                    ["梅州县电视台", "梅州市电视台", "广东省电视台", "湖南省芒果台", "中央电视台"],
                                    ["腾讯官方号", "百度官方号", "爱奇艺官方号", "微博官方号", "星途杯公众号"],
                                    ["抖音官方号", "快手官方号", "小红书官方号", "娱乐世界平台", "客都官方平台"]
                                ]
                            },
                            pathItems: [
                                {
                                    title: "平台身份",
                                    desc: "报名参赛自动录入娱乐世界\n未来之星艺术人才储备资源"
                                },
                                {
                                    title: "展示窗口",
                                    desc: "未来之星随时可以发布动态\n娱乐世界内容创作也可发布"
                                },
                                {
                                    title: "作品参与",
                                    desc: "获奖选手直接参与短剧拍摄\n潜力选手集训参与短剧拍摄"
                                },
                                {
                                    title: "更大舞台",
                                    desc: "优秀人才娱乐世界签约孵化\n全面输送剧组综艺选秀培养"
                                }
                            ]
                        }
                    },
                    {
                        id: "register",
                        title: "06 报名入口",
                        desc: "填写信息，开启你的星途之旅",
                        component: "RegisterForm",
                        data: {
                            // 报名入口（图中三个按钮）
                            entryBtns: [
                                { type: "选手报名", icon: "🎤" },
                                { type: "机构报名", icon: "🏢" },
                                { type: "合作报名", icon: "🤝" }
                            ],
                            // 公众号/专栏入口（图中粉色按钮）
                            channelBtns: [
                                "星途杯公众号",
                                "娱乐世界星途杯专栏"
                            ],
                            // 表单字段（图中需要的4个字段）
                            formFields: [
                                { label: "姓名", type: "text", required: true },
                                { label: "手机号", type: "tel", required: true },
                                { label: "性别", type: "select", options: ["男", "女"], required: true },
                                { label: "年龄", type: "number", required: true }
                            ],
                            submitText: "提交报名",
                            successMsg: "报名成功！工作人员将在3个工作日内与你联系"
                        }
                    },
                ],
                footer: {
                    copyright: "© 2026 星途杯大赛 版权所有",
                    contact: "咨询电话：400-888-9999 | 官方微信：xingtubei2026",
                },
            });
        }, 500);
    });
};

import axios from 'axios';
// 创建 axios 实例
const request = axios.create({
    baseURL: process.env.VUE_APP_BASE_API || 'http://localhost:1770', // 使用环境变量
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// 添加响应拦截器
// 修改响应拦截器
request.interceptors.response.use(
    response => {
        // 处理成功的响应数据
        if (response.data && response.data.code === 5 && response.data.message === "未登录!") {
            // 清除本地存储的认证信息
            localStorage.removeItem('token');
            localStorage.removeItem('systemAdmin');
            // 跳转到登录页面
            window.location.href = '/login';
            // 返回拒绝状态，阻止后续处理
            return Promise.reject(new Error('UNAUTHORIZED'));
        }
        return response;
    },
    error => {
        // 处理错误响应
        if (error.response && error.response.data) {
            const { code, message } = error.response.data;
            // 检查是否为未登录状态
            if (code === 5 && message === "未登录!") {
                // 清除本地存储的认证信息
                localStorage.removeItem('token');
                localStorage.removeItem('systemAdmin');
                // 跳转到登录页面
                window.location.href = '/login';
                // 返回特定错误，便于上层识别
                return Promise.reject(new Error('UNAUTHORIZED'));
            }
        }
        return Promise.reject(error);
    }
);

const getAdminId = () => {
    const adminData = localStorage.getItem('systemAdmin');
    if (adminData) {
        try {
            const parsedData = JSON.parse(adminData);
            return parsedData.id;
        } catch (error) {
            console.error('解析 systemAdmin 数据失败:', error);
            return null;
        }
    }
    return null;
};

const getToken = () => {
    return localStorage.getItem('token');
};
/**
 * 获取品牌商代理设置详情
 */
export function getOfficialInfo(params) {
    return request({
        url: `/official/getOfficialInfo`,
        method: 'GET',
        params,

    });
}
/**
 * 获取品牌商代理设置详情
 */
export function getBanner(params) {
    return request({
        url: `/official/getBanner`,
        method: 'GET',
        params: {
            "adminId": getAdminId()
        },
        headers: {
        // 若项目有token等通用头，需保留，示例：
        'token': getToken()
    },
    });
}
export function updateBannerApi(data) {
    return request({
        url: '/official/updateBanner',
        method: 'post',
        data:data,
        headers: {
            // 若项目有token等通用头，需保留，示例：
            'token': getToken()
        },
    });
}

/**
 * 上传接口
 */
export function uploadFileApi(data) {
    return request({
        url: `/official/uploadFile`,
        method: 'post',
        data,
        // 关键：强制设置请求头为undefined，让浏览器自动生成multipart/form-data（带边界符）
        headers: {
            'Content-Type': undefined, // 覆盖全局拦截器的Content-Type
            // 若项目有token等通用头，需保留，示例：
             'token': getToken()
        },
        // 可选：axios默认处理FormData，但显式指定更稳妥
        transformRequest: [function (data) {
            return data;
        }]
    });
}

/**
 * 提交报名
 * @param data
 * @returns {*}
 */
export function insertRegister(data) {
    return request({
        url: '/official/insertRegister',
        method: 'post',
        data:data,
        headers: {
            // 若项目有token等通用头，需保留，示例：
            'token': getToken()
        },
    });
}

/**
 * 获取报名
 * @param data
 * @returns {*}
 */
export function getRegisterList(data) {
    return request({
        url: '/official/getRegisterList',
        method: 'get',
        params: data,
        headers: {
            // 若项目有token等通用头，需保留，示例：
            'token': getToken()
        },
    });
}

/**
 * 获取公司
 * @param data
 * @returns {*}
 */
export function getSystemAdminList(data) {
    return request({
        url: '/official/getSystemAdminList',
        method: 'get',
        params: data,
        headers: {
            // 若项目有token等通用头，需保留，示例：
            'token': getToken()
        },
    });
}
/**
 * 编辑公司
 * @param data
 * @returns {*}
 */
export function updateSystemAdmin(data) {
    return request({
        url: '/official/updateSystemAdmin',
        method: 'post',
        data:data,
        headers: {
            // 若项目有token等通用头，需保留，示例：
            'token': getToken()
        },
    });
}

/**
 * 验证码
 */
export function getImgCode(params) {
    return request({
        url: `/login/getImgCode`,
        method: 'GET',
        params,
    });
}

/**
 * 登录
 * @param data
 * @returns {Promise<axios.AxiosResponse<any>>}
 */
export function signin(data) {
    return request({
        url: '/login/signin',
        method: 'post',
        data:data
    });
}